import { generate } from "../../../core/js/utils/componentUtils";
import { init as rrInit } from "../../../core/js/components/richRelevanceComponent";

import { isRightRailActive } from '../../../core/js/utils/rrUtils';
import { getRROverrides } from "./richRelevanceComponentOverrides";

export function onStateChange(store) {
    return;
}
export function init(store, overrides = {}) {
    const rrOverrides = getRROverrides(store.getState());
    const config = {
        name: 'productYmalRRComponent',
        templateLocation: '.dom-ymal-rr',
        watch: ['core.rrRecs.recs'],
        onStateChange: onStateChange,
        children: [
            [rrInit, rrOverrides]
        ]
    };
    return generate(config, store, overrides);
}
